import type { AllEffect, ForkEffect } from 'redux-saga/effects';
import { all, fork } from 'redux-saga/effects';
import { hardwareSaga } from './hardware/sagas';
import { monitorSaga } from './monitors/sagas';
import { searchSaga } from './search/sagas';

export function* adminSaga<T>(): Generator<AllEffect<ForkEffect<void>>, void, T> {
  yield all([fork(hardwareSaga), fork(monitorSaga), fork(searchSaga)]);
}
